import type { ReactNode } from 'react'
import type { Lang } from '../../../lib/i18n'
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card'
import { cn } from '../../../components/ui/utils'

interface Props {
  title: string
  children: ReactNode
  actions?: ReactNode
  className?: string
  contentClassName?: string
  lang?: Lang
}

export function SectionCard({ title, children, actions, className, contentClassName, lang }: Props) {
  return (
    <Card className={cn('overflow-hidden', className)}>
      <CardHeader className="flex flex-row items-center justify-between gap-2 border-b bg-secondary/40 py-3">
        <CardTitle
          className={cn(
            'text-xs font-semibold uppercase tracking-wider text-muted-foreground',
            // Arabic heading font +10% (design guidance, bench-HOP-ORDER-DETAIL.CB-A)
            lang === 'ar' && 'text-[1.1em]',
          )}
        >
          {title}
        </CardTitle>
        {actions}
      </CardHeader>
      <CardContent className={cn('pt-4', contentClassName)}>{children}</CardContent>
    </Card>
  )
}
